import { render, staticRenderFns } from "./ExperimentResource.vue?vue&type=template&id=00689e8a&scoped=true&"
import script from "./ExperimentResource.vue?vue&type=script&lang=js&"
export * from "./ExperimentResource.vue?vue&type=script&lang=js&"
import style1 from "../../../assets/css/chunkUpload.css?vue&type=style&index=1&id=00689e8a&scoped=true&lang=css&"
import style2 from "../../../assets/css/resources.css?vue&type=style&index=2&id=00689e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00689e8a",
  null
  
)

export default component.exports